import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../lib/api.service';
import { LogService } from '../../lib/log.service';
import { Assessment } from '../../models/assessment-admin';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { Router } from '@angular/router';

@Component({
    selector: 'assessments-listing.component',
    templateUrl: 'assessments-listing.component.html',
    styleUrls: ['./assessments-listing.component.scss'],
    standalone: false,
})
export class AssessmentsListingPage implements OnInit {
    assessments: Assessment[] = [];
    isLoaded: boolean = false;

    constructor(
        private api: ApiService,
        private logService: LogService,
        private router: Router
    ) {}

    ngOnInit() {
        this.assessmentListing();
    }

    assessmentListing() {
        this.api.get('assessment/listing').subscribe(
            (result: any) => {
                this.assessments = Assessment.initializeArray(result.data);
                this.logService.event(
                    AnalyticEvent.event.assessmentListingLoaded
                );
                this.isLoaded = true;
            },
            (error: any) => {
                this.logService.debug(
                    'Error getting courses. ' + error.message
                );
                this.isLoaded = true;
            }
        );
    }
    doCreate() {
        this.router.navigate(['/admin/assessment/new']);
    }

    onEdit(assessmentId: number) {
        this.router.navigate(['/admin/assessment/' + assessmentId + '/edit']);
    }
}
